var map = {
	"./404.json": 8035,
	"./account.json": 2732,
	"./blockbuster.json": 7666,
	"./blog.json": 3179,
	"./cinema.json": 1003,
	"./faq.json": 2835,
	"./footer.json": 3564,
	"./get-started.json": 9432,
	"./header.json": 6466,
	"./index.json": 6169,
	"./info.json": 6982,
	"./privacy.json": 728,
	"./schools.json": 5922,
	"./sign-in.json": 4468,
	"./subreader-ambassadoer.json": 4699,
	"./subscription.json": 1938,
	"./terms.json": 8119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2016;